<template>
    <div>
         <div v-html="yandexReviews"></div>
    </div>
</template>

<script>
export default {
    computed: {
        yandexReviews() {
            return this.$store.state.clinic.organization.form.front.reviews;
        }
    },
    mounted() {
        const iframe = document.getElementsByTagName('iframe')[0];
        console.log(iframe.contentWindow.document);
    }
};
</script>

<style lang="scss" scoped>

</style>